export const getDeviceMemory = () => {
  const memory = window.navigator.deviceMemory;
  if (memory === 8) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/deviceMemory#value
    // looks like the max value for memeory is 8, which is a little out-dated
    return 'at least 8';
  }
  return memory;
};
